import React from 'react';
import { formatDateTimeForSearchTree, searchItemCss } from '../utils';
import './SearchItem.scss';
export const SearchItem = ({ title, badge, date, isActive = false, onClick = () => { }, className, overrideCss, }) => {
    const { searchItem, searchItemBadge, searchItemText, searchItemTitle } = searchItemCss({ className, overrideCss, isActive });
    return (React.createElement("button", { type: "button", onClick: onClick, className: searchItem },
        React.createElement("div", { className: searchItemTitle }, title),
        date || badge ? (React.createElement("div", null,
            date ? (React.createElement("span", { className: searchItemText }, formatDateTimeForSearchTree(date))) : null,
            badge ? React.createElement("span", { className: searchItemBadge }, badge) : null)) : null));
};
//# sourceMappingURL=SearchItem.js.map